import { combineReducers } from "redux";
import ActionReducer from "./reducer";

export default combineReducers({ ActionReducer });
